/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'

const $nsid = 'app.bsky.feed.getLikes'

export { $nsid }

/** Get like records which reference a subject (by AT-URI and CID). */
const main = l.query(
  $nsid,
  l.params({
    uri: l.string({ format: 'at-uri' }),
    cid: l.optional(l.string({ format: 'cid' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    uri: l.string({ format: 'at-uri' }),
    cid: l.optional(l.string({ format: 'cid' })),
    cursor: l.optional(l.string()),
    likes: l.array(l.ref<Like>((() => like) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Like = {
  $type?: 'app.bsky.feed.getLikes#like'
  indexedAt: l.DatetimeString
  createdAt: l.DatetimeString
  actor: ActorDefs.ProfileView
}

export type { Like }

const like = l.typedObject<Like>(
  $nsid,
  'like',
  l.object({
    indexedAt: l.string({ format: 'datetime' }),
    createdAt: l.string({ format: 'datetime' }),
    actor: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
  }),
)

export { like }
